import React from 'react';
import { post } from "mdui/api/HttpReq";
import { getField, encryptData, procModArgs, autoLoadTables, prepRefModArgs, convUploadform, prepareSearchData, prepareLoadDataParams } from "mdui/form/Util";
import axios from "axios";
import { SecureTokenManager } from "mdui/api/ApiCfg";
import { AlertType } from 'mdui/page/MsgBox';
import RstdCcyModalContent from 'functions/RstdCcyModalContent';
import YesNoModel from 'functions/YesNoModel';
import { t } from "i18next";
import EndpointLogModal from 'functions/EndpointLogModal';
 
const loadTable = async ({ props, formData, updateState, config, ...data }) => {
        console.log("formDatainloadTable", formData)
        let baseMod = formData.baseMod;
        let useBaseMod = baseMod ? true : false;
        if (!useBaseMod && config.pages[config.cPKey].action === 'add') {
                let parentPK = config.initPK || '';
                let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
                let parent = await post('md-mod-cfg', 'init-add-wui-data', { parentPK, action: 'add', ...formData, module: tbl.module });
                let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'add' }, { initOpr: 'add', parentPK, ...formData }, tbl);
                let newFormData = { ...formData, table: nData }
                updateState({ newFormData })
        } else {
                let newFormData = { ...formData }
                updateState({ newFormData })
        }
}
 
const reloadLinkTable = async ({ props, formData, updateTable, config, ...data }) => {
        let name = props.field.name;
        let value = props.field.isTblField ? props.row[name] : formData[name];
        let nFormData = { ...formData, [name]: value };
        let newFormData = await loadTableData({ props, formData: nFormData, updateTable, config, ...data });
        updateTable({ newFormData })
}
 
const loadTableData = async ({ props, formData, updateTable, config, ...data }) => {
        let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
        let parentPK = config.initPK || '';
        let modAction = config.pages[config.cPKey].action || 'search'
        let nFdata = formData && formData || { table: {} }
        let procMod = procModArgs(tbl, nFdata);
        let uData = { table: nFdata.table };
        if (modAction === 'search') {
                uData = nFdata
        }
        if (procMod) {
                uData = { ...uData, ...procMod }
        } else {
                uData = { ...uData, parentPK: nFdata.parentPK, initOpr: nFdata.initOpr }
        }
        let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'read' }, { parentPK, ...uData }, tbl);
        let newFormData = { table: { ...formData.table, ...nData } }
        return newFormData;
}
 
const reloadTable = async ({ props, formData, updateTable, config, ...data }) => {
        let newFormData = loadTableData({ props, formData, updateTable, config, ...data });
        updateTable({ newFormData })
}
 
const resetField = async ({ props, formData, updateState, config, showDialog, ...data }) => {
        // Check if field type is integer - use current logic
        if (props.field.fldType === 'int') {
                let parent = await post('md-mod-cfg', 'reset-field', { module: formData.module, action: formData.action, formData, field: props.field });
                if (parent.RESP_CD === '00') {
                        updateState({ newFormData: { ...formData, ...parent.data } })
                }
                console.log(parent);
        } else {
                // For non-integer fields, show password confirmation popup
                if (showDialog) {
                        showDialog({
                                props: { field: props.field },
                                ok: {
                                        label: 'Reset',
                                        onClick: async (dialogData) => {
                                                try {
                                                        // Get public key for encryption
                                                        let keyData = await post('auth', 'getRSA', {});
                                                        if (!keyData || !keyData.pubKey) {
                                                                console.error('Failed to get public key for encryption');
                                                                return;
                                                        }
 
                                                        // Encrypt the password using the same method as login
                                                        let encryptedPassword = encryptData(dialogData.modalData.password, keyData.pubKey);
 
                                                        // Continue with reset process using encrypted password data
                                                        let parent = await post('md-mod-cfg', 'reset-field', {
                                                                module: formData.module,
                                                                action: formData.action,
                                                                formData,
                                                                field: props.field,
                                                                capturedData: encryptedPassword // Send the encrypted password data
                                                        });
                                                        if (parent.RESP_CD === '00') {
                                                                updateState({ newFormData: { ...formData, ...parent.data } })
                                                        }
                                                        console.log(parent);
                                                } catch (error) {
                                                        console.error('Error during password encryption or reset:', error);
                                                }
                                        }
                                },
                                cancel: { label: 'Cancel', color: 'grey' },
                                labels: {
                                        title: 'Reset Field Confirmation',
                                        description: `Please enter your password to reset the field "${props.field.label || props.field.name}"`
                                },
                                showPasswordFields: true
                        });
                } else {
                        // Fallback if showDialog is not available
                        console.warn('showDialog not available for non-integer field reset');
                        let parent = await post('md-mod-cfg', 'reset-field', { module: formData.module, action: formData.action, formData, field: props.field });
                        if (parent.RESP_CD === '00') {
                                updateState({ newFormData: { ...formData, ...parent.data } })
                        }
                        console.log(parent);
                }
        }
}
 
const loadData = async (module, action, props, formData, tblProps = {}) => {
        let tableCfg = (formData?.table?.[props.module]) ?? { page: 0, perPage: 10 };
        let param = { ...formData, module: props.module, action: props.action, page: (tableCfg.page ? tableCfg.page : 0), perPage: (tableCfg.perPage ? tableCfg.perPage : 10), tblProps: tblProps };
 
        let val = await post(module, action, param);
        let table = {
                ...formData?.table, [props.module]: {
                        page: (tableCfg.page ? tableCfg.page : 0), perPage: (tableCfg.perPage ? tableCfg.perPage : 10),
                        rows: val.content, count: val.totalElements
                }
        }
        return table;
}
 
const reloadCtrlCfg = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
        let fld = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
        if (!fld) {
            console.warn('Field not found');
            updateState({ newFormData: formData });
            return;
        }
    
        var param = prepRefModArgs(fld, formData);
    
        // If no criteria resolved, cleanup ctrlCfg and formData for the callbackArgs field
        if (!param || Object.keys(param).length === 0) {
            const key = `${fld.moduleId}_${fld.name}`;
            const newCtrlCfg = { ...ctrlCfg, [key]: [] };
            const newFormData = { ...formData };
            delete newFormData[fld.name];
            updateState({ newFormData, newCtrlCfg });
            return;
        }
    
        let val = await post('md-mod-cfg', 'read', { ...param, initOpr: 'edit', module: fld.refModNm, action: 'edit'});
    
        let ctrlLbl = 'tabNm';
        let ctrlVal = 'entryId';
    
        if (fld.refCriteria) {
            if (Array.isArray(fld.refCriteria)) {
                const lblItem = fld.refCriteria.find(item => item.ctrlLbl);
                const valItem = fld.refCriteria.find(item => item.ctrlVal);
                if (lblItem?.ctrlLbl) ctrlLbl = lblItem.ctrlLbl;
                if (valItem?.ctrlVal) ctrlVal = valItem.ctrlVal;
            } else if (typeof fld.refCriteria === 'object') {
                if (fld.refCriteria.ctrlLbl) ctrlLbl = fld.refCriteria.ctrlLbl;
                if (fld.refCriteria.ctrlVal) ctrlVal = fld.refCriteria.ctrlVal;
            }
        }
    
        const keyLabelArray = val?.content?.map(item => ({
            val: item[ctrlVal],
            lbl: item[ctrlLbl]
        })) || [];
    
        const key = `${fld.moduleId}_${fld.name}`;
        const newCtrlCfg = { ...ctrlCfg, [key]: keyLabelArray };
        updateState({ newFormData: formData, newCtrlCfg });
    };
 
const setCtrl2Form = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
        let data = procModArgs(props.field, formData);
        let val = await post('md-mod-cfg', 'read', { ...data, initOpr: 'edit', module: props.field.refModNm, action: 'edit', page: 0, perPage: 10 });
        if (val.content) {
                let newFormData = { ...formData, ...val.content[0] }
                updateState({ newFormData })
        }
}
 
const reloadFieldCfg = async ({ props, formData, updateState, config, setCfg, ...args }) => {
 
        let baseMod = formData.baseMod;
        let useBaseMod = baseMod ? true : false;
        var tbls = autoLoadTables(config.pages[config.cPKey])
        // Update tables with hideToolbar
        for (let i = 0; i < tbls.length; i++) {
                let tbl = tbls[i];
                tbl.hideToolbar = useBaseMod;
                tbl.fields[0].hide = useBaseMod;
                let parentPK = config.initPK || '';
                let nFdata = formData && formData || { table: {} }
                let procMod = procModArgs(tbl, nFdata);
                let uData = { table: nFdata.table, initOpr: useBaseMod ? 'edit' : config.initOpr };
 
                if (procMod) {
                        uData = { ...uData, ...procMod }
                } else {
                        uData = { ...uData, parentPK: parentPK }
                }
                let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'read' }, { parentPK, ...uData }, tbl);
                formData.table[tbl.module] = nData[tbl.module]
        }
 
        // Create new config object to ensure React detects the change
        // Since we modified the table field objects directly, we need to create new references
        // for the nested structures so React sees them as changed
        const updatedConfig = {
                ...config,
                pages: {
                        ...config.pages,
                        [config.cPKey]: {
                                ...config.pages[config.cPKey],
                                data: formData,
                                config: {
                                        ...config.pages[config.cPKey].config,
                                        tabs: config.pages[config.cPKey].config.tabs.map(tab => ({
                                                ...tab,
                                                groups: tab.groups?.map(group => ({
                                                        ...group,
                                                        fields: group.fields?.map(field => field) // Create new array reference
                                                })) || tab.groups
                                        })) || config.pages[config.cPKey].config.tabs
                                }
                        }
                }
        };
 
        setCfg(updatedConfig);
}
 
 
 
const loadCcy = async ({ props, formData, ctrlCfg, config, updateState, ...args }) => {
        console.log("propsinLoadCcy", props)
        console.log("formDatainLoadCcy", formData)
        console.log("ctrlCfgCcy", ctrlCfg)
        console.log("configCcy", config)
 
 
        // con
        // let fld = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
        // var param = procModArgs(fld, formData);
        // let val = await post('md-mod-cfg', 'read', { ...param, initOpr: 'edit', module: fld.refModNm, action: 'edit', page: 0, perPage: 10 });
 
        // // Extract ctrlLbl and ctrlVal from refCriteria, defaulting to tabNm and entryId
        // let ctrlLbl = 'tabNm';
        // let ctrlVal = 'entryId';
 
        // if (fld.refCriteria) {
        //         if (Array.isArray(fld.refCriteria)) {
        //                 // Find ctrlLbl and ctrlVal in array
        //                 const lblItem = fld.refCriteria.find(item => item.ctrlLbl);
        //                 const valItem = fld.refCriteria.find(item => item.ctrlVal);
        //                 if (lblItem?.ctrlLbl) ctrlLbl = lblItem.ctrlLbl;
        //                 if (valItem?.ctrlVal) ctrlVal = valItem.ctrlVal;
        //         } else if (typeof fld.refCriteria === 'object') {
        //                 // Direct object access
        //                 if (fld.refCriteria.ctrlLbl) ctrlLbl = fld.refCriteria.ctrlLbl;
        //                 if (fld.refCriteria.ctrlVal) ctrlVal = fld.refCriteria.ctrlVal;
        //         }
        // }
 
        // const keyLabelArray = val?.content?.map(item => ({
        //         val: item[ctrlVal],
        //         lbl: item[ctrlLbl]
        // })) || [];
 
        // let newCtrlCfg = { ...ctrlCfg, [fld['name']]: keyLabelArray }
        // updateState({ newFormData: formData, newCtrlCfg })
}
 
const wuiUpload = async ({ props, formData, files, updateState, event, config, ...data }) => {
        const form = new FormData();
        form.append('file', data?.data?.files[0]);
        form.append('module', props.module);
        form.append('action', 'upload');
        form.append('parentPK', config.initPK);
        //bp-upload/upload
        let val = await post('bp-upload', 'upload', form)
        let parentPK = config.initPK || '';
        let tbl = getField(config.pages[config.cPKey].config, props.field.callbackArgs);
        let nData = await loadData('md-mod-cfg', 'read', { module: tbl.module, action: 'add' }, { initOpr: 'add', parentPK, ...formData }, tbl);
        let newFormData = { ...formData, ...val, table: nData }
        updateState({ newFormData })
}
 
const wuiClearForm = async ({ clearForm, ...data }) => {
        clearForm();
}
 
const exportCsv = async ({ props, formData, config, ...data }) => {
        try {
                const BASE_URL = process.env.REACT_APP_API_BASE_URL + "/api";
                const token = SecureTokenManager.getAccessToken();
                let nFdata = formData || { table: {} };
                let uData = prepareSearchData(nFdata, config, props.field);
                let param = prepareLoadDataParams(uData, props.field, config, 'search', false);
                // Make request with blob response type for file download
                const response = await axios.post(
                        `${BASE_URL}/get/exportCsv`,
                        param || {},
                        {
                                responseType: 'blob',
                                headers: {
                                        Authorization: token ? `Bearer ${token}` : '',
                                        'Content-Type': 'application/json'
                                }
                        }
                );
 
                // Create blob from response
                const blob = new Blob([response.data], { type: 'text/csv' });
 
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
 
                // Get filename from Content-Disposition header or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'export.csv';
                if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                        if (filenameMatch && filenameMatch[1]) {
                                filename = filenameMatch[1].replace(/['"]/g, '');
                                // Handle UTF-8 encoded filenames
                                if (filename.startsWith('UTF-8\'\'')) {
                                        filename = decodeURIComponent(filename.replace('UTF-8\'\'', ''));
                                }
                        }
                }
 
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
 
                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
        } catch (error) {
                console.error('Error exporting CSV:', error);
                throw error;
        }
}
 
const chkTblDetClick = async ({ props, updateState, formData, config, ...data }) => {
        let newFormData = { ...formData }
        updateState({ newFormData })
}
 
const chkTblHdClick = async ({ props, formData, updateState, config, ...data }) => {
        let newFormData = { ...formData }
        updateState({ newFormData })
}
 
const backToHome = async ({ props, formData, updateState, navigate, config, ...data }) => {
        if (navigate) {
                navigate('/home');
        } else {
                window.location.href = `${process.env.PUBLIC_URL}/home`;  // reads /webui from homepage
        }
}
 
const RST_CCY_RATE_FIELDS = ['creditRate', 'debitRate'];
const FORM_DIALOG_META_KEYS = new Set(['errors', 'warnings', 'messages', 'WUI_RESP_MSG', 'table', 'rstdCcyMsg']);
 
const buildDialogMsgParams = (formData, extraParams = {}) => {
        const params = { ...extraParams };
        if (formData && typeof formData === 'object') {
                for (const [key, val] of Object.entries(formData)) {
                        if (FORM_DIALOG_META_KEYS.has(key)) continue;
                        if (val != null && typeof val === 'object') continue;
                        params[key] = val != null && val !== '' ? String(val) : '';
                }
        }
        for (const key of Object.keys(params)) {
                if (params[key] == null) params[key] = '';
        }
        return params;
};
 
const translateFormMsg = (msgKey, formData, module) => {
        if (msgKey == null || msgKey === '') return '';
        const resolvedKey = module && typeof msgKey === 'string' && !msgKey.includes('.')
                ? [`${module}.${msgKey}`, msgKey]
                : msgKey;
        const result = t(resolvedKey, {
                ...buildDialogMsgParams(formData),
                interpolation: { skipOnVariables: false },
        });
        return typeof result === 'string' ? result : String(result ?? '');
};
 
const clearRstdCcyFromFormData = (formData) => {
        const { rstdCcyMsg, ...cleanedFormData } = formData;
        return cleanedFormData;
};

const clearRstdCcyFromAttr = (prevAttr, rstdCcyMsg) => {
        const next = { ...prevAttr };
        let fields = [];
        if (rstdCcyMsg === 'bothCcyRstd') {
                fields = RST_CCY_RATE_FIELDS;
        } else if (rstdCcyMsg === 'dbtCcyRstd') {
                fields = ['debitRate'];
        } else if (rstdCcyMsg === 'cdtCcyRstd') {
                fields = ['creditRate'];        
        }
        for (const field of fields) {
                if (!next[field]) continue;
                const fieldAttr = { ...next[field], readOnly: false };
                next[field] = fieldAttr;
        }
        return next;
};

const applyFormAfterRstdCcyMsg = ({ nFormData, updateState, attr, formData: currentFormData }) => {
        const merged = { ...(currentFormData || {}), ...nFormData };
        const rstdCcyMsgKey = merged.rstdCcyMsg;
        const cleanedFormData = clearRstdCcyFromFormData(merged);
        const nAttr = clearRstdCcyFromAttr(attr || {}, rstdCcyMsgKey);
        updateState({ newFormData: cleanedFormData, newAttr: nAttr, replaceFormData: true, replaceAttr: true });
        return cleanedFormData;
};

const translateRstdCcyModalTitle = (module, formData) => {
        const titleKey = module ? `${module}.rstd_ccy_modal_title` : 'rstd_ccy_modal_title';
        const result = t([titleKey, 'rstd_ccy_modal_title'], {
                ...buildDialogMsgParams(formData),
                defaultValue: 'Restricted Currency Notification',
                interpolation: { skipOnVariables: false },
        });
        return typeof result === 'string' ? result : 'Restricted Currency Notification';
};

const showRstdCcyMsgDialogIfNeeded = ({
        nFormData,
        module,
        updateState,
        showCustomModal,
        hideCustomModal,
        formData,
        attr,
}) => {
        const msgKey = nFormData?.rstdCcyMsg;
        if (msgKey == null || msgKey === '') {
                return false;
        }
        if (!showCustomModal) {
                console.warn('showCustomModal is required for restricted currency notification');
                return false;
        }

        const message = translateFormMsg(msgKey, nFormData, module);
        const title = translateRstdCcyModalTitle(module, nFormData);

        showCustomModal({
                content: (
                        <RstdCcyModalContent
                                message={message}
                                onOk={() => {
                                        hideCustomModal?.();
                                        const cleanedFormData = applyFormAfterRstdCcyMsg({
                                                nFormData,
                                                updateState,
                                                attr,
                                                formData,
                                        });
                                        scrollToFormTargetElement('group', 'pymtDetSection');
                                }}
                        />
                ),
                width: '520px',
                title: title,
        });
        return true;
};
 
const showSummaryWithDialogRT = async ({ props, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data }) => {
     
       
        const action = props.field && props.field.name ? props.field.name : '';
 
        let labels = {
                title: "Online Outward Payment Confirmation",
                description: `Are you sure you want to ${action} the request ?`
        }
        const module = props.field?.module || formData?.module || modNm;

        const openConfirmDialog = (currentFormData) => {
                showCustomModal({
                        content: (
                                <YesNoModel
                                        message={labels.description}
                                        onYes={() => {
                                                hideCustomModal?.();
                                                showSummary({
                                                        props,
                                                        formData: currentFormData,
                                                        updateState,
                                                        validate,
                                                        showDialog,
                                                        showCustomModal,
                                                        hideCustomModal,
                                                        showSummary,
                                                        clearForm,
                                                        loadCfg,
                                                        modNm,
                                                        mtype,
                                                        ...data
                                                });
                                        }}
                                        onNo={() => {
                                                hideCustomModal?.();
                                        }}
                                />
                        ),
                        width: '520px',
                        title: labels.title,
                });
        };
 
 //       if (validate()) {
                let actionValidate = config.pages[config.cPKey].action || 'summary';
                let modPK = config.pages[config.cPKey].modPK || '';
                let parentPK = formData.parentPK || '';
                let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: actionValidate, ...formData, mtype: mtype, wuiFldProps: {field: props.field}, modPK: modPK, parentPK: parentPK });
                if (handleApiError(val, {module, updateState, clearForm, loadCfg, modNm, mtype, ...data})) {
                        return;
                }
                let table = { ...formData.table, ...val.table }
                let nFormData = { ...formData, ...val, table: { ...table } };
                if(action !== 'decline' ){
                        let flag =   await holidayChk({ props, formData:nFormData, updateState, clearForm, loadCfg, modNm, mtype, ...data })
                        if(flag){
                                return;
                        }
                }
                if (showRstdCcyMsgDialogIfNeeded({
                        nFormData,
                        module,
                        updateState,
                        showCustomModal,
                        hideCustomModal,
                        formData,
                        attr: data.attr,
                        onContinue: openConfirmDialog,
                })) {
                        return;
                }
                openConfirmDialog(nFormData);
 //       }

}

const clearSrch = ({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
        loadCfg('md-mod-cfg', 'cfg-read', { module: modNm, action: 'search', mtype: mtype }, null, null, null, {}, {}, true);
}
 
const submitWithDailogRT = async ({ props, submitConfirm, handleApiError, config, formData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data }) => {
        const action = props.field && props.field.name ? props.field.name : '';
 
        let labels = {
                title: "Online Outward Payment Confirmation",
                description: `Are you sure you want to ${action} the request ?`
        }
        let cancel = {};
        const module = props.field?.module || formData?.module || modNm;

        const openConfirmDialog = (currentFormData) => {
                showCustomModal({
                        content: (
                                <YesNoModel
                                        message={labels.description}
                                        onYes={() => {
                                                hideCustomModal?.();
                                                submitConfirm({
                                                        props,
                                                        formData: currentFormData,
                                                        updateState,
                                                        validate,
                                                        showDialog,
                                                        showCustomModal,
                                                        hideCustomModal,
                                                        showSummary,
                                                        clearForm,
                                                        loadCfg,
                                                        modNm,
                                                        mtype,
                                                        ...data
                                                });
                                        }}
                                        onNo={() => {
                                                hideCustomModal?.();
                                        }}
                                />
                        ),
                        width: '520px',
                        title: labels.title,
                });
        };
 
//        if (validate()) {
                let actionValidate = config.pages[config.cPKey].action || 'summary';
                let modPK = config.pages[config.cPKey].modPK || '';
                let parentPK = formData.parentPK || '';
                let val = await post('md-mod-cfg', 'validate', { module: props.field.module, action: actionValidate, ...formData, mtype: mtype, wuiFldProps: {field: props.field}, modPK: modPK, parentPK: parentPK });
                if (handleApiError(val, {module, updateState, clearForm, loadCfg, modNm, mtype, ...data})) {
                        return;
                }
                let table = { ...formData.table, ...val.table }
                let nFormData = { ...formData, ...val, table: { ...table } };
                let flag =   await holidayChk({ props, formData:nFormData, updateState, clearForm, loadCfg, modNm, mtype, ...data })
                if(flag){
                        return;
                }
                if (showRstdCcyMsgDialogIfNeeded({
                        nFormData,
                        module,
                        updateState,
                        showCustomModal,
                        hideCustomModal,
                        formData,
                        attr: data.attr,
                        onContinue: openConfirmDialog,
                })) {
                        return;
                }
                if (action === 'reject' && nFormData?.txStts === 'FAILED') {
                        const message = translateFormMsg('confirmFailedMsg', nFormData, module);
                        const title = translateFormMsg('confirmMsgTitle', nFormData, module);
                        showCustomModal({
                                content: (
                                        <YesNoModel
                                                message={message}
                                                onYes={() => {
                                                        hideCustomModal?.();
                                                        submitConfirm({props, formData: nFormData, updateState, validate, showDialog, showCustomModal, hideCustomModal, showSummary, clearForm, loadCfg, modNm, mtype, ...data});
                                                }}
                                                onNo={() => {
                                                        hideCustomModal?.();
                                                }}
                                />
                        ),
                        width: '520px',
                        title: title,
                });
                        return;
                }
                openConfirmDialog(nFormData);
//        }
}
 
const holidayChk = async ({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
           if (formData.txStts === 'REJECTED') {
                return false;
        }
        formData = { ...formData, productMode: "RT", }
        
        let parent = await post('holiday', 'holiday-chk', { ...formData });
        let payload = { productMode: "RT", debitCcy: formData.debitCcy, creditCcy: formData.creditCcy, txCd: formData.txCd, fxcontractRef: formData.fxcontractRef, interFaceTp: "PGBZOP" }
        let cutOfTimeChkRes = await post('holiday', 'cutoff-chk', payload);

        if (parent && parent.localholiday && parent.localholiday === "Y") {
                let newMsg = { key: t("holiday_msg"), type: AlertType.W };
                updateState({ newFormData: formData, newMsg })
                return true;
        } else if (parent && parent.debitHoliday && parent.debitHoliday === "Y") {
                let newMsg = { key: t("ccy_holiday_msg"), type: AlertType.W };
                updateState({ newFormData: formData, newMsg })
                return true;
        } else if (parent && parent.creditHoliday && parent.creditHoliday === "Y") {
                let newMsg = { key: t("ccy_holiday_msg"), type: AlertType.W };
                updateState({ newFormData: formData, newMsg })
                return true;
        }
        else if (cutOfTimeChkRes && cutOfTimeChkRes.IsCutOff && cutOfTimeChkRes.IsCutOff === "N") {
                let newMsg = { key: t("cutoff_time_msg"), type: AlertType.E };
                updateState({ newFormData: formData, newMsg })
                return true;
        }
        return false;
 
}
 
const holidayChkDbtCcy = async ({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
      let flag =   await holidayChk({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data })
        console.log("flagindebthldChk", flag)
     
}
 
const localHolidayChk = async ({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
        console.log("formDatainlocalHolidayChk", formData)
        let holidayPayload={
                productMode: "RT",
                txCd: formData.txCd,
        }
 
        let parent = await post('holiday', 'holiday-chk', holidayPayload);
        if (parent && parent.localHoliday && parent.localHoliday === "Y") {
                let newMsg = { key: t("holiday_msg"), type: AlertType.W };
                updateState({ newFormData: formData, newMsg })
                return true;
        }
        return false;
}
 
const cutOfTimeChk = async ({ props, formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
        formData = { ...formData, productMode: "RT", }
        let payload = { productMode: "RT", debitCcy: formData.debitCcy, creditCcy: formData.creditCcy, txCd: formData.txCd, fxcontractRef: formData.fxcontractRef, interFaceTp: "PGBZOP" }
 
 
        let parent = await post('holiday', 'cutoff-chk', payload);
        console.log("parentincutOfTimeChk", parent)
        if (parent && parent.IsCutOff && parent.IsCutOff === "Y") {
                let newMsg = { key: t("cutoff_time_msg"), type: AlertType.E };
                updateState({ newFormData: formData, newMsg })
                return true;
        }
        return false;
}
 
const rssiApiCall = async ({ props, ctrlCfg,formData, updateState, clearForm, loadCfg, modNm, mtype, ...data }) => {
        let payload={
                txCd:formData.txCd,
                acctFrBic:formData.acctFrBic,
                acctToBic:formData.acctToBic,
                chnlInstrId:formData.chnlInstrId,
                cdtrBnkCntrycd:formData.cdtrBnkCntrycd,
                creditCcy:formData.creditCcy,
                recvCorrPrefSSI:formData.recvCorrPrefSSI
        }
        const rssiResp = await post('rssi', 'rssi-call', formData);
        console.log("valinrssiApiCall", rssiResp)
        return rssiResp;
}

export const isFormTargetVisible = (el) => {
        if (!el) {
                return false;
        }
        if (el.closest('[hidden]')) {
                return false;
        }
        const style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') {
                return false;
        }
        if (el.offsetParent === null && style.position !== 'fixed') {
                return false;
        }
        const rect = el.getBoundingClientRect();
        return rect.width > 0 || rect.height > 0;
};
export const formTargetId = (type, id) => {
        if (type == null || type === '' || id == null || id === '') {
                return undefined;
        }
        return `mdform-${type}-${id}`;
};
export const scrollToFormTargetElement = (type, id, { focusField = true } = {}) => {
        const elId = formTargetId(type, id);
        if (!elId) {
                return false;
        }
        const el = document.getElementById(elId);
        if (!isFormTargetVisible(el)) {
                return false;
        }
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (focusField && type === 'field') {
                const focusable = el.querySelector(
                        'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'
                );
                if (focusable) {
                        focusable.focus({ preventScroll: true });
                }
        }
        return true;
};
const getAllNonReadOnlyFields = (config, formData) => {
        const fields = [];
        const cPKey = config?.cPKey;
        const pageConfig = config?.pages?.[cPKey]?.config?.pageConfig || [];

        const isHidden = (field) => {
                if (typeof field.hidden === 'function') {
                        return !!field.hidden(formData);
                }
                return field.hidden === true;
        };

        const walkFields = (fieldArr) => {
                (fieldArr || []).forEach((field) => {
                        // nested container (e.g. button-group wrapper: { width, fields: [...] })
                        if (Array.isArray(field.fields)) {
                                walkFields(field.fields);
                                return;
                        }
                        if (field.type === 'button') return;

                        const fldNm = field.fldNm;
                        if (fldNm && field.readOnly !== true && !isHidden(field)) {
                                fields.push(fldNm);
                        }
                });
        };

        pageConfig.forEach((section) => {
                (section.groups || []).forEach((group) => {
                        walkFields(group.fields);
                });
        });

        return fields;
};

const clearSelectedFields = ({ props, formData, updateState, config, ...data }) => {
        const explicitFields = props.field?.clearFields || [];
        const nonReadOnlyFields = getAllNonReadOnlyFields(config, formData);
        const fieldsToClear = Array.from(new Set([...explicitFields, ...nonReadOnlyFields]));

        if (!fieldsToClear.length) {
                console.warn('clearSelectedFields: no fields resolved to clear');
                return;
        }

        const newFormData = { ...formData };
        fieldsToClear.forEach((fieldName) => {
                newFormData[fieldName] = '';
        });
        updateState({ newFormData });
};
const endPointInfo = async ({ props, formData, ctrlCfg, config, updateState, showCustomModal, hideCustomModal, ...args }) => {
    const raw = formData?.bodyRawMsg;
    showCustomModal({
        content: (
            <EndpointLogModal data={raw}
                onOk={() => { hideCustomModal?.(); }}
            />
        ),
        title: `Body Raw Message`,
        width: '700px',
    });
}
export { loadTable, backToHome, reloadCtrlCfg, resetField, reloadTable, setCtrl2Form, reloadFieldCfg, loadCcy, wuiUpload, wuiClearForm, translateFormMsg, exportCsv, loadData, chkTblDetClick, chkTblHdClick, loadTableData, reloadLinkTable, showSummaryWithDialogRT, clearSrch, submitWithDailogRT, holidayChk, holidayChkDbtCcy, localHolidayChk, cutOfTimeChk, rssiApiCall, clearSelectedFields, showRstdCcyMsgDialogIfNeeded,endPointInfo }